<template>
    <div class="mobile-menu"
         :class="{shown: shown}"
         @click="$emit('click')">
      <div class="mobile-menu_head">
        <logo-link green_logo/>
        <burger-menu
          collapse
          dark
          @click="$emit('close')"/>
      </div>
      <div class="mobile-menu__menus">
        <mobile-menu-list
          :menus="menus"
        />
      </div>
      <div class="mobile-menu__footer">
        <div class="mobile-menu__footer-row">
          <social-links light no_padding/>
          <language-switcher
            dropdown_top
            light
            thin_dropdown
            hide_current_locale_from_list/>
        </div>
        <hr class="mobile-menu__line"/>
        <footer-secondary-menu
          :menus="footer_secondary_menu"
          class="mobile-menu__footer-menu"/>
        <hr class="mobile-menu__line" />
        <copyrights class="mobile-menu__copyrights"/>
      </div>
    </div>
</template>

<script>
import LogoLink from "./LogoLink.vue";
import BurgerMenu from "./BurgerMenu.vue";
import ChevronDownIcon from "../icons/ChevronDownIcon.vue";
import IsLink from "../slots/IsLink.vue";
import SlideUpDown from "../modules/SlideUpDown.vue";
import MobileMenuList from "./MobileMenuList.vue";
import SocialLinks from "../parts/footer/SocialLinks.vue";
import LanguageSwitcher from "./LanguageSwitcher.vue";
import Copyrights from "./Copyrights.vue";
import FooterSecondaryMenu from "../parts/footer/FooterSecondaryMenu.vue";

export default {
  name: "MobileMenu",
  components: {
    FooterSecondaryMenu,
    Copyrights,
    LanguageSwitcher,
    SocialLinks,
    MobileMenuList,
    SlideUpDown,
    IsLink,
    ChevronDownIcon,
    BurgerMenu,
    LogoLink
  },
  computed: {
    footer_menus() {
      return this.$context?.footer_menus || []
    },
    footer_secondary_menu() {
      return this.footer_menus[1]?.menus || []
    },
  },
  data() {
    return {
      active_dropdown: 0
    }
  },
  props: {
    menus: {
      type: Array,
      default: () => []
    },
    shown: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openChildrenMenu(id) {
      if (this.active_dropdown === id) {
        this.active_dropdown = 0
        return
      }
      this.active_dropdown = id
    }
  }
}
</script>
